import e from "./_nativeCreate.js";
var h = "__lodash_hash_undefined__";
function s(t, a) {
  var _ = this.__data__;
  return this.size += this.has(t) ? 0 : 1, _[t] = e && a === void 0 ? h : a, this;
}
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_hashSet.js
// module id = 1478
// module chunks = 41